<template>
  <div id="app">
    <v-data-table
      v-if="!loading"
      :headers="headers"
      :items="companies"
      :search="search"
      sort-by="licenseRemainingDays"
      class="elevation-1">

      <template v-slot:top>
        <v-toolbar flat>
          <v-dialog v-model="dialog" max-width="800px">
            <!-- <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">New Company</v-btn>
            </template> -->
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.name" label="Company name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.email" label="Company email"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field v-model="editedItem.date" label="License expiration date" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="editedItem.date" @input="menu = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-switch v-model="editedItem.messagingEnabled" hide-details color="info" inset label="Messaging"></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-switch v-model="editedItem.videoInterviewEnabled" hide-details color="info" inset label="Video Interview"></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-switch v-model="editedItem.surveyEnabled" hide-details color="info" inset label="Survey"></v-switch>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-spacer></v-spacer>

          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip slot="append" bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="mr-2" v-on="on" color="primary" @click="editItem(item)">mdi-pencil</v-icon>
          </template>
          <span>Edit company</span>
        </v-tooltip>
        <v-tooltip slot="append" bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="mr-2" color="primary" v-on="on" @click="restoreItem(item)">mdi-backup-restore</v-icon>
          </template>
          <span>Restore company</span>
        </v-tooltip>
      </template>

      <!-- <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template> -->

      <template v-slot:item.licenseExpirationDateFormatted="{ item }">
        <v-chip :color="getColor(item.licenseRemainingDays)" dark>{{ item.licenseExpirationDateFormatted }}</v-chip>
      </template>

      <template v-slot:item.messagingEnabled="{ item }">
        <v-simple-checkbox v-model="item.messagingEnabled" disabled></v-simple-checkbox>
      </template>
      <template v-slot:item.videoInterviewEnabled="{ item }">
        <v-simple-checkbox v-model="item.videoInterviewEnabled" disabled></v-simple-checkbox>
      </template>
      <template v-slot:item.surveyEnabled="{ item }">
        <v-simple-checkbox v-model="item.surveyEnabled" disabled></v-simple-checkbox>
      </template>
    </v-data-table>

    <v-data-table
      v-if="loading"
      item-key="name"
      class="elevation-1"
      loading
      loading-text="Loading... Please wait">
    </v-data-table>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { companyStatusType } from "../../enums/companyStatusType";

export default {
  data: () => ({
    loading: false,
    dialog: false,
    search: '',
    menu: false,
    params: {
      isFullLicense: false,
      companyStatusType: companyStatusType.Deleted
    },
    headers: [
      { text: 'Company id', value: 'companyId' },
      { text: 'Company name', value: 'name' },      
      { text: 'Company email', value: 'email' },
      { text: 'License expires', value: 'licenseExpirationDateFormatted' },
      { text: 'Messaging', value: 'messagingEnabled' },
      { text: 'Video Interview', value: 'videoInterviewEnabled' },
      { text: 'Survey', value: 'surveyEnabled' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    //companies: [],
    editedIndex: -1,
    editedItem: {
      name: '',
      email: '',
      companyId: '',
      licenseExpirationDate: '',
      licenseRemainingDays: 0,
      date: new Date().toISOString().substr(0, 10),
      messagingEnabled: false,
      videoInterviewEnabled: false,
      surveyEnabled: false,
    },
    defaultItem: {
      name: '',
      email: '',
      companyId: '',
      licenseExpirationDate: '',
      licenseRemainingDays: 0,
      date: new Date().toISOString().substr(0, 10),
      messagingEnabled: false,
      videoInterviewEnabled: false,
      surveyEnabled: false,
    },
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Company' : 'Edit Company'
    },
    ...mapState({
      companies: state => state.companiesStore.items
    })
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
  },

  created () {
    this.loading = true;
    this.fetchCompanies(this.params).then(() => (this.loading = false));
  },

  methods: {
    ...mapActions({
      fetchCompanies: "fetchCompanies",
      createCompany: "createCompany",
      updateCompany: "updateCompany",
      restoreCompany: "restoreCompany",
      deleteCompany: "deleteCompany"
    }),
    editItem (item) {
      this.editedIndex = this.companies.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.date = this.editedItem.licenseExpirationDate.substr(0, 10)
      this.dialog = true
    },

    restoreItem (item) {
      var confirmed = confirm('Are you sure you want to restore this company?');
      if (confirmed && confirmed === true) {
        this.restoreCompany(item.companyId)
          .then(response => {
            console.log("Company restore: " + response);
            this.loading = true;
            this.fetchCompanies(this.params).then(() => (this.loading = false));
        })
        .catch(error => { console.log(error); });
      }
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      this.editedItem.licenseExpirationDate = new Date(this.editedItem.date);
      if (this.editedIndex > -1) {
        this.updateCompany(this.editedItem)
          .then(response => {
            console.log("Company update: " + response);
            this.loading = true;
            this.fetchCompanies(this.params).then(() => (this.loading = false));
        })
        .catch(error => { console.log(error); });
        //Object.assign(this.companies[this.editedIndex], this.editedItem)
      } else {
        this.editedItem.isFullLicense = false;
        this.createCompany(this.editedItem)
          .then(response => {
            console.log("Company create: " + response);
            this.loading = true;
            this.fetchCompanies(this.params).then(() => (this.loading = false));
        })
        .catch(error => { console.log(error); });

       // this.companies.push(this.editedItem)
      }
      this.close()
    },

    getColor (expiration) {
      if (expiration < 0)
        return 'red'
      else if (expiration < 5)
        return 'orange'
      return 'green'
    },
  },
}
</script>